export const APPOINTMENTS_ALL = 'APPOINTMENTS_ALL';
export const APPOINTMENTS_ALL_SUCCESS = 'APPOINTMENTS_ALL_SUCCESS';
export const APPOINTMENTS_GET_BY_DATES = 'APPOINTMENTS_GET_BY_DATES';
export const APPOINTMENTS_GET_BY_DATES_SUCCESS = 'APPOINTMENTS_GET_BY_DATES_SUCCESS';
export const APPOINTMENTS_GET_BY_DATES_FAILED =
	'APPOINTMENTS_GET_BY_DATES_FAILED';
export const APPOINTMENTS_GET = 'APPOINTMENTS_GET';
export const APPOINTMENTS_GET_SUCCESS = 'APPOINTMENTS_GET_SUCCESS';
export const APPOINTMENTS_CREATE = 'APPOINTMENTS_CREATE';
export const APPOINTMENTS_CREATE_SUCCESS = 'APPOINTMENTS_CREATE_SUCCESS';
export const APPOINTMENTS_UPDATE = 'APPOINTMENTS_UPDATE';
export const APPOINTMENTS_UPDATE_SUCCESS = 'APPOINTMENTS_UPDATE_SUCCESS';
export const APPOINTMENTS_DELETE = 'APPOINTMENTS_DELETE';
export const APPOINTMENTS_DELETE_SUCCESS = 'APPOINTMENTS_DELETE_SUCCESS';
export const APPOINTMENTS_GET_AGENDA = 'APPOINTMENTS_GET_AGENDA';
export const APPOINTMENTS_GET_AGENDA_SUCCESS =
	'APPOINTMENTS_GET_AGENDA_SUCCESS';
export const APPOINTMENTS_GET_AGENDA_FAILED = 'APPOINTMENTS_GET_AGENDA_FAILED';